<div class="row tab-nav">
  <tabset [vertical]="true">

    <tab [heading]="'Super Admin'" customClass="list-group-item list-group-item-action">
      <div class="tab-pane mt-3 fade show active">
        <div class="d-flex justify-content-between mb-2">
          <label>{{ translationKeys.InstitutionManagement.SelectSOP | translate }}</label>
          <div class="">
            <input type="checkbox"
              (change)="checkAll($event, 'sa')"
              class="custom-control-input" id="sa"
              [(ngModel)]="allSAChecked"
              >
            <label for="sa">{{ translationKeys.InstitutionManagement.SelectAll | translate }}</label>
          </div>
        </div>
        <div class="col-auto p-0">
          <input inputSanitizer type="text" class="form-control search-input"
            placeholder="{{ translationKeys.InstitutionManagement.Search | translate }}..." [(ngModel)]="searchTextSA">
        </div>
        <div class="checkbox-container-list">
          <div class="mb-2" *ngFor='let saSOP of saSOPS'>
            <div *ngIf="showSOPSA(saSOP.title)">
              <input type="checkbox"
                class="custom-control-input sa"
                (change)="checkOne($event, saSOP.sopid,'sa')"
                [checked]="isChecked(saSOP.sopid)"
                id="customCheck-{{saSOP.sopid}}">
              <label for="customCheck-{{saSOP.sopid}}">{{layoutService.translateText(saSOP.title) | labelSanitizer}}</label>
            </div>
          </div>
        </div>
      </div>
    </tab>
    <tab [heading]="'Country Admin'" customClass="list-group-item list-group-item-action">
      <div class="tab-pane mt-3 fade show active">
        <div class="d-flex justify-content-between mb-2">
          <label>{{ translationKeys.InstitutionManagement.SelectSOP | translate }}</label>
          <div class="">
            <input type="checkbox"
              (change)="checkAll($event, 'ca')"
              class="custom-control-input" id="ca"
              [(ngModel)]="allCAChecked"
              >
            <label for="ca">{{ translationKeys.InstitutionManagement.SelectAll | translate }}</label>
          </div>
        </div>
        <div class="col-auto p-0">
          <input inputSanitizer type="text" class="form-control search-input"
            placeholder="{{ translationKeys.InstitutionManagement.Search | translate }}..." [(ngModel)]="searchTextCA">
        </div>
        <div class="checkbox-container-list">
          <div class="mb-2" *ngFor='let caSOP of caSOPS'>
            <div *ngIf="showSOPCA(caSOP.title)">
              <input type="checkbox"
                class="custom-control-input ca"
                (change)="checkOne($event, caSOP.sopid,'ca')"
                [checked]="isChecked(caSOP.sopid)"
                id="customCheck-{{caSOP.sopid}}">
              <label for="customCheck-{{caSOP.sopid}}">{{layoutService.translateText(caSOP.title) | labelSanitizer}}</label>
            </div>
          </div>
        </div>
      </div>
    </tab>
   

     
  </tabset>
</div>
